import { Link } from "react-router-dom";
import { EMAIL } from "@/constants/business";

export default function PolitiqueConfidentialitePage() {
  return (
    <div className="min-h-screen bg-white px-4 md:px-8 py-16 max-w-3xl mx-auto" data-testid="politique-confidentialite-page">
      <Link to="/" className="text-orange font-semibold text-sm">← Retour à l'accueil</Link>
      <h1 className="font-heading font-bold text-3xl text-navy mt-6 mb-8">Politique de confidentialité</h1>
      <div className="space-y-6 text-sm text-muted-foreground leading-relaxed">
        <section>
          <h2 className="font-heading font-semibold text-navy text-lg mb-2">Données collectées</h2>
          <p>
            Lorsque vous remplissez un formulaire de devis ou de réservation de place dans le camion, nous collectons
            les informations que vous renseignez volontairement : nom, téléphone, email, adresses, détails de votre
            demande et, si vous le souhaitez, des photos ou vidéos.
          </p>
        </section>
        <section>
          <h2 className="font-heading font-semibold text-navy text-lg mb-2">Utilisation des données</h2>
          <p>
            Vos informations sont utilisées uniquement pour répondre à votre demande de transport, de déménagement,
            de devis ou de réservation. Aucun partage à des tiers.
          </p>
        </section>
        <section>
          <h2 className="font-heading font-semibold text-navy text-lg mb-2">Vos droits</h2>
          <p>
            Vous pouvez demander l'accès, la rectification ou la suppression de vos données à tout moment en nous
            contactant à l'adresse {EMAIL}.
          </p>
        </section>
      </div>
    </div>
  );
}
